var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAutoConnect(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H36C42.3513 0.5 47.5 5.64873 47.5 12V36C47.5 42.3513 42.3513 47.5 36 47.5H12C5.64873 47.5 0.5 42.3513 0.5 36V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_18_2181)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H36C42.3513 0.5 47.5 5.64873 47.5 12V36C47.5 42.3513 42.3513 47.5 36 47.5H12C5.64873 47.5 0.5 42.3513 0.5 36V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_18_2181)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2181)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_2181",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 12H12V36H36V12Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_2181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 17.15V20.85C34 23.1 33.1 24 30.85 24H28.15C25.9 24 25 23.1 25 20.85V17.15C25 14.9 25.9 14 28.15 14H30.85C33.1 14 34 14.9 34 17.15Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 27.15V30.85C23 33.1 22.1 34 19.85 34H17.15C14.9 34 14 33.1 14 30.85V27.15C14 24.9 14.9 24 17.15 24H19.85C22.1 24 23 24.9 23 27.15Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7805 33.9995C26.5105 33.9995 26.2605 33.8495 26.1305 33.6195C26.0005 33.3795 26.0005 33.0995 26.1405 32.8595L27.1105 31.2395C27.3205 30.8795 27.7805 30.7695 28.1405 30.9795C28.5005 31.1895 28.6105 31.6495 28.4005 32.0095L28.2205 32.3095C30.6905 31.6695 32.5105 29.4295 32.5105 26.7695C32.5105 26.3595 32.8505 26.0195 33.2605 26.0195C33.6705 26.0195 34.0005 26.3595 34.0005 26.7795C34.0005 30.7595 30.7605 33.9995 26.7805 33.9995Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 21.97C14.34 21.97 14 21.64 14 21.22C14 17.24 17.24 14 21.22 14C21.5 14 21.74 14.15 21.88 14.38C22.01 14.62 22.01 14.9 21.87 15.14L20.9 16.75C20.68 17.11 20.22 17.23 19.87 17.01C19.51 16.8 19.4 16.34 19.61 15.98L19.79 15.68C17.33 16.32 15.5 18.56 15.5 21.22C15.5 21.64 15.16 21.97 14.75 21.97Z",
    fill: "#34D399"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_2181",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_2181",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 41.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAutoConnect);
export default __webpack_public_path__ + "static/media/icon-auto-connect.c4e0bbb8a57d7262f4c8729dbb60b2e0.svg";
export { ForwardRef as ReactComponent };